<template>
  <div class="card card-medios noBackground textCard noPadding noBorderRadius" style="margin-bottom:10px!important">
    <div class="row no-gutters">
      <div class="col">
        <div class="user-avatar">
          <div class="img-avatar"
            :style="{ 'background-image': 'url(' + item.noticiero_img + '),url(' + defaultImage + ')', 'width': '35px', 'height': '35px' }">
          </div>
          <div class="data-avatar">
            <p class="user-name blanco" style="font-size:14px">{{ geTitulo(item) > 20 ?
              geTitulo(item).slice(0, 20) + '...' : geTitulo(item) }}</p>
            <p class="user">{{ item.canal }}</p>
          </div>
        </div>
      </div>
      <div class="col-auto">
        <a v-if="item.entrada != 'T' && item.entrada != 'R'" :href="item.link ? item.link : item.media" target="_BLANK"
          class="button more-button tooltip tooltip-left" :data-tooltip="getTooltip()">
          <svg class="svgFB" v-if="item.entrada == 'FB'" width="30px" height="30px" viewBox="0 0 24 24">
            <path
              d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />
          </svg>
          <svg class="svgTW" v-if="item.entrada == 'TW'" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" />
          </svg>
          <svg class="svgYoutube" v-if="item.entrada == 'Y'" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
            <path
              d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" />
          </svg>
          <svg class="svgInsta" v-if="item.entrada == 'I'" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
            <path
              d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z" />
          </svg>
          <svg class="svgPD" v-if="item.entrada == 'PD'" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
            <path d="M20 6v12H4V6h16m2-2H2v14s0 2 2 2h16s2 0 2-2V4m-12 9H6V8h4v5m8 0h-7v-2h7v2m0-3h-7V8h7v2z" />
          </svg>
          <svg v-if="item.entrada == 'TK'" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
            viewBox="0 0 32 32">
            <path
            d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
          </svg>
        </a>
        <div class="button more-button tooltip tooltip-left" :data-tooltip="getTooltip()" v-else>
          <svg class="svgTV" v-if="item.entrada == 'T'" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="30px" height="30px" viewBox="0 0 24 24">
            <path
              d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
          </svg>
          <svg class="svgRadio" v-if="item.entrada == 'R'" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
            <path
              d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" />
          </svg>
          <svg v-if="item.entrada == 'TK'" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
            viewBox="0 0 32 32">
            <path
              d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
          </svg>
        </div>
        <!--<div class=" dropdown">
                        <div class="dropdown-option">
                            <ul>
                                <li>Opcion1</li>
                                <li>Opcion2</li>
                                <li>Opcion3</li>
                            </ul>
                        </div>
        </div>-->
      </div>
    </div>
    <div class="body noPadding noMargin noBorderRadius backgroundVerde">
      <div class="row">
        <div :class="['col-sm-12', { 'col-md-8': item.imagen }]">
          <p class="post-description blanco" style="margin-top:1px" v-if="item.entrada == 'R' || item.entrada == 'T'"
            v-html="convertStringAndTrim(item.titulo)"></p>
          <p class="post-description blanco" style="margin-top:1px" v-else v-html="getTitle(item)"></p>
        </div>
        <div class="col-sm-12 col-md-4" v-if="item.imagen">
          <div class="post-img noBackground" style="height:100%;width:100%;margin:auto!important;">
            <img :src="item.imagen" />
          </div>
        </div>
      </div>
    </div>

    <div class="card-actions" style="padding-top:5px">
      <div class="textPanel-footer">
        <div class="row no-gutters">
          <div class="col-11">
            <span class="verde">{{ parseFecha(item.fecha) }}</span>
          </div>
          <div class="col-1 button small noMargin noBackground linkArrow tooltip" data-tooltip="Ver más"
            @click="goToNote">
            <font-awesome-icon icon="arrow-right" />
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { strings } from "@/services/strings.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink } from "@fortawesome/free-solid-svg-icons";

library.add(faLink);
export default {
  name: "textCard",
  props: ["item", "from"],
  mixins: [strings],
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      defaultImage: this.$store.state.defaultNote
    };
  },
  beforeMount() {

    switch (this.item.entrada) {
      case "T":
        if (
          this.item.noticiero_img == "" ||
          this.item.noticiero_img == undefined
        ) {
          var notiKey =
            typeof this.item.noticiero == "object"
              ? this.item.codigo_noticiero
              : this.item.noticiero;
          this.item.noticiero_img =
            "https://newscastv2.s3.amazonaws.com/assets/img/tv/img_tv_" +
            notiKey +
            ".png";
        }
        this.item.imagen = this.item.thumb;
        this.defaultImage = this.$store.state.defaultTV;
        break;
      case "R":
        if (
          this.item.noticiero_img == "" ||
          this.item.noticiero_img == undefined
        ) {
          var notiKey =
            typeof this.item.noticiero == "object"
              ? this.item.codigo_noticiero
              : this.item.noticiero;
          this.item.noticiero_img =
            "https://newscastv2.s3.amazonaws.com/assets/img/radio/img_radio_" +
            notiKey +
            ".png";
        }
        this.item.imagen = null;
        this.defaultImage = this.$store.state.defaultRadio;
        break;
      case "Y":
        var key = this.item.key;
        var img_arr = key.split("-");
        this.item.imagen =
          "https://img.youtube.com/vi/" + img_arr[1] + "/default.jpg";
        if (this.item.noticiero_img == undefined) {
          this.item.noticiero_img = this.$store.state.defaultYoutube;
        }
        this.defaultImage = this.$store.state.defaultYoutube;
        break;
      case "I":
        if (this.item.noticiero_img == undefined) {
          this.item.noticiero_img = this.$store.state.defaultInstagram;
        }
        this.defaultImage = this.$store.state.defaultInstagram;
        break;
      case "TW":
        if (this.item.noticiero_img == undefined) {
          this.item.noticiero_img = this.$store.state.defaultTwitter;
        }
        this.defaultImage = this.$store.state.defaultTwitter;
        break;
      case "FB":
        if (this.item.noticiero_img == undefined) {
          this.item.noticiero_img = this.$store.state.defaultFacebook;
        }
        this.defaultImage = this.$store.state.defaultFacebook;
        break;
      case "TK":
        if (this.item.noticiero_img == undefined) {
          this.item.noticiero_img = this.$store.state.defaultTiktok;
        }
        this.defaultImage = this.$store.state.defaultTiktok;
        this.item.noticiero_nombre = this.item.autor;
        console.log(this.item, "=====item");
        break;

      default:
        this.item.imagen = null;
        break;
    }
  },
  methods: {
    goToNote() {
      this.$emit("goToNote", this.item);
    },
    parseFecha(fecha) {
      //fecha= "2020-02-06 16:13:12"
      moment.tz.setDefault("America/Mexico_City");

      var tmp = moment(fecha);

      var f = moment
        .tz(tmp, "America/Mexico_City")
        .format("DD/MM/YYYY HH:mm:ss");
      return f;
    },
    loadMore() {
      this.$emit("loadMore");
    },
    goToNotes() {
      var key_src =
        this.item.entrada == "T" || this.item.entrada == "R"
          ? this.item.codigo_noticiero
          : this.item.key_src;
      this.item.key_src = key_src;
      this.$emit("goToNotes", this.item);
    },
    getTitle(item) {
      var str = item.titulo ? item.titulo : item.descripcion;
      if(item.entrada == "TK"){
        str = item.title;
      }
      var title = str != undefined ? str : "";
      var titulo = title;
      
      if (title.length > 140) {
        titulo = title.slice(0, 140);
        titulo += "...";
      }
      return titulo;
    },
    geTitulo(ite){
      var t = ite.noticiero_nombre?ite.noticiero_nombre:ite.autor;
      return t; 
    },
    getTooltip() {
      var tooltip = "";
      switch (this.item.entrada) {
        case 'T': tooltip = "Television"; break;
        case 'R': tooltip = "Radio"; break;
        case 'I': tooltip = "ver en Instagram"; break;
        case 'FB': tooltip = "ver en Facebook"; break;
        case 'TW': tooltip = "ver en Twitter"; break;
        case 'PD': tooltip = "ver en Medio Digital"; break;
        case 'TK': tooltip = "ver en Tiktok"; break;
      }
      return tooltip;
    }
  }
};
</script>
<style scoped>
.linkArrow {
  color: white;
  text-align: right;
  padding: 0px 5px 0px 0px;
  cursor: pointer;
}

.linkArrow:hover {
  color: #00b99e;
}
</style>